import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Common/Configurations/AuthContext';
import apiService from '../../Common/Configurations/APIService';
import config from '../../Common/Configurations/APIConfig';
import Header from '../../Common/Layout/Header';
import { Modal } from "react-bootstrap";
import destinationData from '../../Data/PackageDestinations.json';
import currencyFlags from '../../Data/CurrencyFlags.json';
import './MaterPackageCreate.css';
import PackageTabs from "../Packages/PackageTabs";

// Default image for package
const DEFAULT_IMAGE = "/assets/images/default-package.jpg";
const generateGuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`pkg-toast ${type === 'success' ? 'pkg-toast-success' : 'pkg-toast-error'}`}>
      <div className="pkg-toast-content">
        <span>{type === 'success' ? '✅' : '❌'}</span>
        <span className="pkg-toast-message">{message}</span>
        <button onClick={onClose} className="pkg-toast-close" type="button" aria-label="Close">×</button>
      </div>
    </div>
  );
};

// Flight Sub-component
const FlightSection = ({ flight, index, onUpdate, onRemove }) => {
  const updateFlight = (field, value) => {
    onUpdate(index, { ...flight, [field]: value });
  };

  const updateSegment = (segIndex, field, value) => {
    const segments = [...(flight.Segments || [])];
    if (!segments[segIndex]) segments[segIndex] = {};
    segments[segIndex] = { ...segments[segIndex], [field]: value };
    updateFlight('Segments', segments);
  };

  const addSegment = () => {
    const segments = [...(flight.Segments || [])];
    segments.push({ From: '', To: '', Airline: '', FlightNo: '', DepartureTime: '', ArrivalTime: '' });
    updateFlight('Segments', segments);
  };

  const removeSegment = (segIndex) => {
    const segments = [...(flight.Segments || [])];
    segments.splice(segIndex, 1);
    updateFlight('Segments', segments);
  };

  return (
    <div className="pkg-subcard pkg-subcard-flight">
      <div className="pkg-subcard-header">
        <strong>✈️ Flight {index + 1}</strong>
        <button className="pkg-btn-remove" onClick={() => onRemove(index)} type="button">Remove</button>
      </div>
      <div className="pkg-grid-3">
        <div className="pkg-form-group">
          <label className="pkg-label">Airline</label>
          <input className="pkg-input" value={flight.Airline || ''} onChange={(e) => updateFlight('Airline', e.target.value)} placeholder="Airline" />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Flight Number</label>
          <input className="pkg-input" value={flight.FlightNumber || ''} onChange={(e) => updateFlight('FlightNumber', e.target.value)} placeholder="Flight No" />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Cabin Class</label>
          <select className="pkg-select" value={flight.CabinClass || ''} onChange={(e) => updateFlight('CabinClass', e.target.value)}>
            <option value="">Select</option>
            <option value="Economy">Economy</option>
            <option value="Premium Economy">Premium Economy</option>
            <option value="Business">Business</option>
            <option value="First">First</option>
          </select>
        </div>
      </div>
      <div className="pkg-grid-3">
        <div className="pkg-form-group">
          <label className="pkg-label">Departure City</label>
          <input className="pkg-input" value={flight.DepartureCity || ''} onChange={(e) => updateFlight('DepartureCity', e.target.value)} placeholder="From" />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Arrival City</label>
          <input className="pkg-input" value={flight.ArrivalCity || ''} onChange={(e) => updateFlight('ArrivalCity', e.target.value)} placeholder="To" />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Journey Type</label>
          <select className="pkg-select" value={flight.JourneyType || ''} onChange={(e) => updateFlight('JourneyType', e.target.value)}>
            <option value="">Select</option>
            <option value="One Way">One Way</option>
            <option value="Round Trip">Round Trip</option>
            <option value="Multi City">Multi City</option>
          </select>
        </div>
      </div>
      <div className="pkg-grid-3">
        <div className="pkg-form-group">
          <label className="pkg-label">Departure Date/Time</label>
          <input type="datetime-local" className="pkg-input" value={flight.DepartureDateTime || ''} onChange={(e) => updateFlight('DepartureDateTime', e.target.value)} />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Arrival Date/Time</label>
          <input type="datetime-local" className="pkg-input" value={flight.ArrivalDateTime || ''} onChange={(e) => updateFlight('ArrivalDateTime', e.target.value)} />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Baggage</label>
          <input className="pkg-input" value={flight.Baggage || ''} onChange={(e) => updateFlight('Baggage', e.target.value)} placeholder="e.g., 30kg" />
        </div>
         <div className="pkg-grid-3">
        <div className="pkg-form-group">
          <label className="pkg-label">Adults</label>
          <input type="number" className="pkg-input" value={flight.Adults || 0} onChange={(e) => updateFlight('Adults', parseInt(e.target.value) || 0)} min="0" placeholder="0" />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Kids</label>
          <input type="number" className="pkg-input" value={flight.Kids || 0} onChange={(e) => updateFlight('Kids', parseInt(e.target.value) || 0)} min="0" placeholder="0" />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Infants</label>
          <input type="number" className="pkg-input" value={flight.Infants || 0} onChange={(e) => updateFlight('Infants', parseInt(e.target.value) || 0)} min="0" placeholder="0" />
        </div>
      </div>
      </div>
      <div className="pkg-grid-3">
        <div className="pkg-form-group">
          <label className="pkg-label">Sale Price</label>
          <input type="number" className="pkg-input" value={flight.Price || 0} onChange={(e) => updateFlight('Price', parseFloat(e.target.value) || 0)} min="0" step="0.01" placeholder="0.00" />
        </div>
      </div>
      <div className="pkg-checkbox-row">
        <input type="checkbox" id={`flight-included-${index}`} checked={flight.IsIncluded !== undefined ? flight.IsIncluded : true} onChange={(e) => updateFlight('IsIncluded', e.target.checked)} />
        <label htmlFor={`flight-included-${index}`}>Included in package</label>
      </div>

      <div style={{ marginTop: '12px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <label className="pkg-label" style={{ margin: 0 }}>Segments</label>
          <button className="pkg-btn pkg-btn-xs pkg-btn-secondary" onClick={addSegment} type="button">+ Add Segment</button>
        </div>
        {(flight.Segments || []).map((seg, segIdx) => (
          <div key={segIdx} className="pkg-subcard-nested">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
              <strong style={{ fontSize: '12px' }}>Segment {segIdx + 1}</strong>
              <button className="pkg-btn-remove" style={{ padding: '2px 8px' }} onClick={() => removeSegment(segIdx)} type="button">×</button>
            </div>
            <div className="pkg-grid-3">
              <input className="pkg-input" value={seg.From || ''} onChange={(e) => updateSegment(segIdx, 'From', e.target.value)} placeholder="From" />
              <input className="pkg-input" value={seg.To || ''} onChange={(e) => updateSegment(segIdx, 'To', e.target.value)} placeholder="To" />
              <input className="pkg-input" value={seg.Airline || ''} onChange={(e) => updateSegment(segIdx, 'Airline', e.target.value)} placeholder="Airline" />
            </div>
            <div className="pkg-grid-3" style={{ marginTop: '8px' }}>
              <input className="pkg-input" value={seg.FlightNo || ''} onChange={(e) => updateSegment(segIdx, 'FlightNo', e.target.value)} placeholder="Flight No" />
              <input type="datetime-local" className="pkg-input" value={seg.DepartureTime || ''} onChange={(e) => updateSegment(segIdx, 'DepartureTime', e.target.value)} />
              <input type="datetime-local" className="pkg-input" value={seg.ArrivalTime || ''} onChange={(e) => updateSegment(segIdx, 'ArrivalTime', e.target.value)} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Hotel Sub-component
const HotelSection = ({ hotel, index, onUpdate, onRemove }) => {
  const updateHotel = (field, value) => {
    onUpdate(index, { ...hotel, [field]: value });
  };

  return (
    <div className="pkg-subcard pkg-subcard-hotel">
      <div className="pkg-subcard-header">
        <strong>🏨 Hotel {index + 1}</strong>
        <button className="pkg-btn-remove" onClick={() => onRemove(index)} type="button">Remove</button>
      </div>
      <div className="pkg-grid-3">
        <div className="pkg-form-group">
          <label className="pkg-label">Hotel Name</label>
          <input className="pkg-input" value={hotel.HotelName || ''} onChange={(e) => updateHotel('HotelName', e.target.value)} placeholder="Hotel" />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">City</label>
          <input className="pkg-input" value={hotel.City || ''} onChange={(e) => updateHotel('City', e.target.value)} placeholder="City" />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Star Rating</label>
          <select className="pkg-select" value={hotel.StarRating || 0} onChange={(e) => updateHotel('StarRating', parseInt(e.target.value) || 0)}>
            <option value="0">Select</option>
            <option value="1">⭐</option>
            <option value="2">⭐⭐</option>
            <option value="3">⭐⭐⭐</option>
            <option value="4">⭐⭐⭐⭐</option>
            <option value="5">⭐⭐⭐⭐⭐</option>
          </select>
        </div>
      </div>
      <div className="pkg-grid-3">
        <div className="pkg-form-group">
          <label className="pkg-label">Room Type</label>
          <input className="pkg-input" value={hotel.RoomType || ''} onChange={(e) => updateHotel('RoomType', e.target.value)} placeholder="Room" />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Meal Plan</label>
          <select className="pkg-select" value={hotel.MealPlan || ''} onChange={(e) => updateHotel('MealPlan', e.target.value)}>
            <option value="">Select</option>
            <option value="Room Only">Room Only</option>
            <option value="Breakfast">Breakfast</option>
            <option value="Half Board">Half Board</option>
            <option value="Full Board">Full Board</option>
            <option value="All Inclusive">All Inclusive</option>
          </select>
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Rooms</label>
          <input type="number" className="pkg-input" value={hotel.NumberOfRooms || 0} onChange={(e) => updateHotel('NumberOfRooms', parseInt(e.target.value) || 0)} min="1" placeholder="0" />
        </div>
      </div>
      <div className="pkg-grid-3">
        <div className="pkg-form-group">
          <label className="pkg-label">Nights</label>
          <input type="number" className="pkg-input" value={hotel.Nights || 0} onChange={(e) => updateHotel('Nights', parseInt(e.target.value) || 0)} min="0" placeholder="0" />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Check-in</label>
          <input type="date" className="pkg-input" value={hotel.CheckInDate || ''} onChange={(e) => updateHotel('CheckInDate', e.target.value)} />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Check-out</label>
          <input type="date" className="pkg-input" value={hotel.CheckOutDate || ''} onChange={(e) => updateHotel('CheckOutDate', e.target.value)} />
        </div>
      </div>
      <div className="pkg-grid-3">
        <div className="pkg-form-group">
          <label className="pkg-label">Sale Price</label>
          <input type="number" className="pkg-input" value={hotel.Price || 0} onChange={(e) => updateHotel('Price', parseFloat(e.target.value) || 0)} min="0" step="0.01" placeholder="0.00" />
        </div>
      </div>
      <div className="pkg-checkbox-row">
        <input type="checkbox" id={`hotel-included-${index}`} checked={hotel.IsIncluded !== undefined ? hotel.IsIncluded : true} onChange={(e) => updateHotel('IsIncluded', e.target.checked)} />
        <label htmlFor={`hotel-included-${index}`}>Included in package</label>
      </div>
    </div>
  );
};

// Sightseeing Sub-component
const SightseeingSection = ({ sightseeing, index, onUpdate, onRemove }) => {
  const updateSightseeing = (field, value) => {
    onUpdate(index, { ...sightseeing, [field]: value });
  };

  return (
    <div className="pkg-subcard pkg-subcard-sightseeing">
      <div className="pkg-subcard-header">
        <strong>🗺️ Sightseeing {index + 1}</strong>
        <button className="pkg-btn-remove" onClick={() => onRemove(index)} type="button">Remove</button>
      </div>
      <div className="pkg-grid-3">
        <div className="pkg-form-group">
          <label className="pkg-label">Sightseeing Name</label>
          <input className="pkg-input" value={sightseeing.SightseeingName || ''} onChange={(e) => updateSightseeing('SightseeingName', e.target.value)} placeholder="Name" />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Destination</label>
          <input className="pkg-input" value={sightseeing.Destination || ''} onChange={(e) => updateSightseeing('Destination', e.target.value)} placeholder="City" />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Type</label>
          <select className="pkg-select" value={sightseeing.Type || ''} onChange={(e) => updateSightseeing('Type', e.target.value)}>
            <option value="">Select</option>
            <option value="Tour">Tour</option>
            <option value="Activity">Activity</option>
            <option value="Adventure">Adventure</option>
            <option value="Cultural">Cultural</option>
            <option value="Entertainment">Entertainment</option>
            <option value="Natural">Natural</option>
          </select>
        </div>
      </div>
      <div className="pkg-grid-3">
        <div className="pkg-form-group">
          <label className="pkg-label">Description</label>
          <input className="pkg-input" value={sightseeing.Description || ''} onChange={(e) => updateSightseeing('Description', e.target.value)} placeholder="Brief" />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Duration</label>
          <input className="pkg-input" value={sightseeing.Duration || ''} onChange={(e) => updateSightseeing('Duration', e.target.value)} placeholder="e.g., 2hrs" />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Date</label>
          <input type="date" className="pkg-input" value={sightseeing.Date || ''} onChange={(e) => updateSightseeing('Date', e.target.value)} />
        </div>
      </div>
      <div className="pkg-grid-3">
        <div className="pkg-form-group">
          <label className="pkg-label">Sale Price</label>
          <input type="number" className="pkg-input" value={sightseeing.Price || 0} onChange={(e) => updateSightseeing('Price', parseFloat(e.target.value) || 0)} min="0" step="0.01" placeholder="0.00" />
        </div>
      </div>
      <div className="pkg-checkbox-row">
        <input type="checkbox" id={`sight-included-${index}`} checked={sightseeing.IsIncluded !== undefined ? sightseeing.IsIncluded : true} onChange={(e) => updateSightseeing('IsIncluded', e.target.checked)} />
        <label htmlFor={`sight-included-${index}`}>Included in package</label>
      </div>
    </div>
  );
};

// Transfer Sub-component
const TransferSection = ({ transfer, index, onUpdate, onRemove }) => {
  const updateTransfer = (field, value) => {
    onUpdate(index, { ...transfer, [field]: value });
  };

  return (
    <div className="pkg-subcard pkg-subcard-transfer">
      <div className="pkg-subcard-header">
        <strong>🚗 Transfer {index + 1}</strong>
        <button className="pkg-btn-remove" onClick={() => onRemove(index)} type="button">Remove</button>
      </div>
      <div className="pkg-grid-3">
        <div className="pkg-form-group">
          <label className="pkg-label">From</label>
          <input className="pkg-input" value={transfer.FromLocation || ''} onChange={(e) => updateTransfer('FromLocation', e.target.value)} placeholder="Pickup" />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">To</label>
          <input className="pkg-input" value={transfer.ToLocation || ''} onChange={(e) => updateTransfer('ToLocation', e.target.value)} placeholder="Dropoff" />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Type</label>
          <select className="pkg-select" value={transfer.Type || ''} onChange={(e) => updateTransfer('Type', e.target.value)}>
            <option value="">Select</option>
            <option value="Airport Transfer">Airport Transfer</option>
            <option value="Intercity">Intercity</option>
            <option value="Sightseeing">Sightseeing</option>
            <option value="Private">Private</option>
            <option value="Shared">Shared</option>
          </select>
        </div>
      </div>
      <div className="pkg-grid-3">
        <div className="pkg-form-group">
          <label className="pkg-label">Vehicle</label>
          <input className="pkg-input" value={transfer.VehicleDetails || ''} onChange={(e) => updateTransfer('VehicleDetails', e.target.value)} placeholder="Sedan/SUV" />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Pickup Time</label>
          <input type="time" className="pkg-input" value={transfer.PickupTime || ''} onChange={(e) => updateTransfer('PickupTime', e.target.value)} />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Date</label>
          <input type="date" className="pkg-input" value={transfer.Date || ''} onChange={(e) => updateTransfer('Date', e.target.value)} />
        </div>
      </div>
      <div className="pkg-grid-3">
        <div className="pkg-form-group">
          <label className="pkg-label">Sale Price</label>
          <input type="number" className="pkg-input" value={transfer.Price || 0} onChange={(e) => updateTransfer('Price', parseFloat(e.target.value) || 0)} min="0" step="0.01" placeholder="0.00" />
        </div>
      </div>
      <div className="pkg-checkbox-row">
        <input type="checkbox" id={`transfer-included-${index}`} checked={transfer.IsIncluded !== undefined ? transfer.IsIncluded : true} onChange={(e) => updateTransfer('IsIncluded', e.target.checked)} />
        <label htmlFor={`transfer-included-${index}`}>Included in package</label>
      </div>
    </div>
  );
};

// Preview Component
const PackagePreview = ({ formData, imagePreview, currencyOptions, priceSharingItems, onClose }) => {
  const getCurrencySymbol = (code) => {
    const currency = currencyOptions.find(c => c.code === code);
    return currency ? currency.symbol : code;
  };

  const renderStars = (rating) => {
    return '⭐'.repeat(rating) + '☆'.repeat(5 - rating);
  };

  return (
    <div className="pkg-card pkg-preview-card">
      <div className="pkg-preview-header">
        <h5 style={{ margin: 0, fontWeight: 700, fontSize: '15px' }}>👁️ Package Preview</h5>
        <button className="pkg-btn-remove" onClick={onClose} type="button">Close Preview</button>
      </div>
      <div className="pkg-preview-body">
        <div className="pkg-preview-doc">
          <div className="pkg-preview-doc-header">
            {imagePreview && (
              <img src={imagePreview} alt="Package" style={{ maxHeight: '150px', borderRadius: '8px', marginBottom: '12px' }} />
            )}
            <h1>{formData.Title || 'Untitled Package'}</h1>
            <p>{formData.Description || 'No description provided'}</p>
            <div className="pkg-badge-row">
              <span className="pkg-badge pkg-badge-info">📋 {formData.Status}</span>
              {formData.IsLive && <span className="pkg-badge pkg-badge-success">🟢 Live</span>}
              {formData.IsWebsite && <span className="pkg-badge pkg-badge-info">🌐 Website</span>}
              {formData.TravelType && <span className="pkg-badge pkg-badge-warning">✈️ {formData.TravelType}</span>}
            </div>
          </div>

          <div className="pkg-preview-section">
            <div className="pkg-preview-section-title">📊 Quick Info</div>
            <div className="pkg-grid-3">
              <div style={{ fontSize: '13px' }}><strong>Duration:</strong> {formData.Duration || `${formData.TotalDays}D/${formData.TotalNights}N`}</div>
              <div style={{ fontSize: '13px' }}><strong>Destinations:</strong> {formData.DestinationsCover || 'N/A'}</div>
              <div style={{ fontSize: '13px' }}><strong>Holiday Key:</strong> {formData.HolidayKey || 'N/A'}</div>
            </div>
          </div>

          {(formData.Adults > 0 || formData.Kids > 0 || formData.Infants > 0) && (
            <div className="pkg-preview-section">
              <div className="pkg-preview-section-title">👤 Person Details</div>
              <div className="pkg-grid-4">
                <div style={{ fontSize: '13px' }}><strong>Adults:</strong> {formData.Adults || 0}</div>
                <div style={{ fontSize: '13px' }}><strong>Kids:</strong> {formData.Kids || 0}</div>
                <div style={{ fontSize: '13px' }}><strong>Infants:</strong> {formData.Infants || 0}</div>
                <div style={{ fontSize: '13px' }}><strong>Total:</strong> {(formData.Adults || 0) + (formData.Kids || 0) + (formData.Infants || 0)}</div>
              </div>
            </div>
          )}

          <div className="pkg-preview-section">
            <div className="pkg-preview-section-title">💰 Pricing</div>
            <div className="pkg-grid-3">
              <div style={{ fontSize: '13px' }}><strong>Flight:</strong> {getCurrencySymbol(formData.Currency)}{formData.FlightPrice || 0}</div>
              <div style={{ fontSize: '13px' }}><strong>Hotel:</strong> {getCurrencySymbol(formData.Currency)}{formData.HotelPrice || 0}</div>
              <div style={{ fontSize: '13px' }}><strong>Sightseeing:</strong> {getCurrencySymbol(formData.Currency)}{formData.SightSeeingPrice || 0}</div>
              <div style={{ fontSize: '13px' }}><strong>Transfers:</strong> {getCurrencySymbol(formData.Currency)}{formData.TransferPrice || 0}</div>
              <div style={{ fontSize: '13px' }}><strong>Other:</strong> {getCurrencySymbol(formData.Currency)}{formData.OtherPrice || 0}</div>
              <div style={{ fontSize: '13px' }}><strong>Purchase:</strong> {getCurrencySymbol(formData.Currency)}{formData.PurchasePrice || 0}</div>
            </div>
            <div className="pkg-preview-sale">
              <strong style={{ fontSize: '16px' }}>Sale Price: {getCurrencySymbol(formData.Currency)}{formData.SalePrice || 0}</strong>
              {formData.PurchasePrice > 0 && formData.SalePrice > 0 && (
                <span style={{ marginLeft: '12px', fontSize: '13px', color: formData.SalePrice > formData.PurchasePrice ? '#065f46' : '#dc2626' }}>
                  (Margin: {getCurrencySymbol(formData.Currency)}{(formData.SalePrice - formData.PurchasePrice).toFixed(2)})
                </span>
              )}
            </div>
          </div>

          {priceSharingItems.length > 0 && (
            <div className="pkg-preview-section">
              <div className="pkg-preview-section-title">👥 Price Sharing</div>
              <div className="pkg-grid-auto">
                {priceSharingItems.map((item, idx) => (
                  <div key={idx} style={{ padding: '8px 12px', backgroundColor: '#ffffff', borderRadius: '6px', border: '1px solid #e9ecef', fontSize: '12.5px' }}>
                    <div><strong>{item.SharingType}</strong></div>
                    <div>Price: {getCurrencySymbol(formData.Currency)}{item.Price}</div>
                    {item.AdultPrice > 0 && <div>Adult: {getCurrencySymbol(formData.Currency)}{item.AdultPrice}</div>}
                    {item.KidPrice > 0 && <div>Kid: {getCurrencySymbol(formData.Currency)}{item.KidPrice}</div>}
                    {item.InfantPrice > 0 && <div>Infant: {getCurrencySymbol(formData.Currency)}{item.InfantPrice}</div>}
                  </div>
                ))}
              </div>
            </div>
          )}

          {(formData.ValidityFrom || formData.ValidityTo || formData.StartedDate) && (
            <div className="pkg-preview-section">
              <div className="pkg-preview-section-title">📅 Validity</div>
              <div className="pkg-grid-3">
                {formData.StartedDate && <div style={{ fontSize: '13px' }}><strong>Started:</strong> {new Date(formData.StartedDate).toLocaleDateString()}</div>}
                {formData.ValidityFrom && <div style={{ fontSize: '13px' }}><strong>From:</strong> {new Date(formData.ValidityFrom).toLocaleDateString()}</div>}
                {formData.ValidityTo && <div style={{ fontSize: '13px' }}><strong>To:</strong> {new Date(formData.ValidityTo).toLocaleDateString()}</div>}
              </div>
            </div>
          )}

          {(formData.Inclusions.length > 0 || formData.Exclusions.length > 0) && (
            <div className="pkg-preview-section">
              <div className="pkg-preview-section-title">✅ Inclusions & ❌ Exclusions</div>
              <div className="pkg-grid-2">
                <div>
                  <strong style={{ fontSize: '13px' }}>Inclusions:</strong>
                  <ul style={{ fontSize: '13px', paddingLeft: '18px', margin: '4px 0' }}>
                    {formData.Inclusions.map((item, i) => <li key={i}>✅ {item}</li>)}
                  </ul>
                </div>
                <div>
                  <strong style={{ fontSize: '13px' }}>Exclusions:</strong>
                  <ul style={{ fontSize: '13px', paddingLeft: '18px', margin: '4px 0' }}>
                    {formData.Exclusions.map((item, i) => <li key={i}>❌ {item}</li>)}
                  </ul>
                </div>
              </div>
            </div>
          )}

          {formData.Itinerary.length > 0 && (
            <div className="pkg-preview-section">
              <div className="pkg-preview-section-title">📋 Itinerary</div>
              {formData.Itinerary.map((day, idx) => (
                <div key={idx} style={{ marginBottom: '12px', padding: '10px', backgroundColor: '#ffffff', borderRadius: '6px', border: '1px solid #e9ecef' }}>
                  <h4 style={{ margin: '0 0 4px 0', fontSize: '14.5px', color: '#00897E' }}>Day {day.Day || idx + 1}: {day.Title || ''}</h4>
                  <p style={{ margin: '2px 0', fontSize: '13px' }}>{day.Description || ''}</p>
                  {day.Location && <div style={{ fontSize: '13px' }}><strong>📍 Location:</strong> {day.Location}</div>}
                  {day.Meals && <div style={{ fontSize: '13px' }}><strong>🍽️ Meals:</strong> {day.Meals}</div>}
                  {day.Note && <div style={{ fontSize: '13px' }}><strong>📝 Note:</strong> {day.Note}</div>}

                  {(day.Flights || []).length > 0 && (
                    <div style={{ marginTop: '6px' }}>
                      <strong style={{ fontSize: '13px' }}>✈️ Flights:</strong>
                      {day.Flights.map((f, fi) => (
                        <div key={fi} style={{ padding: '3px 8px', backgroundColor: '#f8f9fa', marginTop: '3px', borderRadius: '4px', fontSize: '12px' }}>
                          {f.Airline} {f.FlightNumber} - {f.DepartureCity} → {f.ArrivalCity}
                          <span style={{ marginLeft: '6px', color: '#6c757d' }}>({f.CabinClass})</span>
                          {f.IsIncluded && <span style={{ marginLeft: '6px', color: '#10b981' }}>✅</span>}
                        </div>
                      ))}
                    </div>
                  )}

                  {(day.Hotels || []).length > 0 && (
                    <div style={{ marginTop: '6px' }}>
                      <strong style={{ fontSize: '13px' }}>🏨 Hotels:</strong>
                      {day.Hotels.map((h, hi) => (
                        <div key={hi} style={{ padding: '3px 8px', backgroundColor: '#f8f9fa', marginTop: '3px', borderRadius: '4px', fontSize: '12px' }}>
                          {h.HotelName} - {h.City} ({h.Nights} nights)
                          <span style={{ marginLeft: '6px' }}>{renderStars(h.StarRating)}</span>
                          {h.IsIncluded && <span style={{ marginLeft: '6px', color: '#10b981' }}>✅</span>}
                        </div>
                      ))}
                    </div>
                  )}

                  {(day.Sightseeing || []).length > 0 && (
                    <div style={{ marginTop: '6px' }}>
                      <strong style={{ fontSize: '13px' }}>🗺️ Sightseeing:</strong>
                      {day.Sightseeing.map((s, si) => (
                        <div key={si} style={{ padding: '3px 8px', backgroundColor: '#f8f9fa', marginTop: '3px', borderRadius: '4px', fontSize: '12px' }}>
                          {s.SightseeingName} - {s.Destination} ({s.Duration || 'N/A'})
                          {s.IsIncluded && <span style={{ marginLeft: '6px', color: '#10b981' }}>✅</span>}
                        </div>
                      ))}
                    </div>
                  )}

                  {(day.Transfers || []).length > 0 && (
                    <div style={{ marginTop: '6px' }}>
                      <strong style={{ fontSize: '13px' }}>🚗 Transfers:</strong>
                      {day.Transfers.map((t, ti) => (
                        <div key={ti} style={{ padding: '3px 8px', backgroundColor: '#f8f9fa', marginTop: '3px', borderRadius: '4px', fontSize: '12px' }}>
                          {t.FromLocation} → {t.ToLocation} ({t.Type})
                          {t.IsIncluded && <span style={{ marginLeft: '6px', color: '#10b981' }}>✅</span>}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}

          {formData.Terms.length > 0 && (
            <div className="pkg-preview-section">
              <div className="pkg-preview-section-title">📄 Terms & Conditions</div>
              {formData.Terms.map((term, idx) => (
                <div key={idx} style={{ marginBottom: '4px' }}>
                  <strong style={{ fontSize: '13px' }}>{term.Title}</strong>
                  {term.Description && <p style={{ margin: '2px 0 0 0', fontSize: '12px', color: '#6c757d' }}>{term.Description}</p>}
                </div>
              ))}
            </div>
          )}

          {(formData.ContactName || formData.ContactPhoneNumber || formData.ContactEmail) && (
            <div className="pkg-preview-section">
              <div className="pkg-preview-section-title">📞 Contact</div>
              <div className="pkg-grid-3">
                {formData.ContactName && <div style={{ fontSize: '13px' }}><strong>Name:</strong> {formData.ContactName}</div>}
                {formData.ContactPhoneNumber && <div style={{ fontSize: '13px' }}><strong>Phone:</strong> {formData.ContactPhoneNumber}</div>}
                {formData.ContactEmail && <div style={{ fontSize: '13px' }}><strong>Email:</strong> {formData.ContactEmail}</div>}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const STEPS = [
  { id: 1, label: 'Basic Info' },
  { id: 2, label: 'Destinations & Travelers' },
  { id: 3, label: 'Dates & Pricing' },
  { id: 4, label: 'Settings & Contact' },
  { id: 5, label: 'Itinerary' },
  { id: 6, label: 'Inclusions & Terms' },
];

// Main Component
const MasterPackageCreate = () => {
  const { user, loading: authLoading, refreshUserProfile } = useAuth();
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  // AI Package Modal States
  const [showPackageTypeSelectionModal, setShowPackageTypeSelectionModal] = useState(false);
  const [showNoConnectsModal, setShowNoConnectsModal] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [isCheckingConnects, setIsCheckingConnects] = useState(false);

  // DMC Selection States
  const [selectedDmc, setSelectedDmc] = useState(null);
  const [dmcList, setDmcList] = useState([]);
  const [loadingDmcList, setLoadingDmcList] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [showPreview, setShowPreview] = useState(false);
  const [showEstimation, setShowEstimation] = useState(false);

  // Price Sharing state
  const [priceSharingItems, setPriceSharingItems] = useState([]);

  // Destination suggestion state
  const [destinationInput, setDestinationInput] = useState('');
  const [destinationSuggestions, setDestinationSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectedDestinations, setSelectedDestinations] = useState([]);
  const [selectedPlaces, setSelectedPlaces] = useState([]);
  const [showPlaceDropdown, setShowPlaceDropdown] = useState(false);
  const [currentDestination, setCurrentDestination] = useState(null);

  // Currency options from currencyFlags
  const [currencyOptions, setCurrencyOptions] = useState([]);

  // Process currency data from currencyFlags.json
  useEffect(() => {
    if (currencyFlags && Array.isArray(currencyFlags)) {
      const sortedCountries = [...currencyFlags].sort((a, b) =>
        a.country.localeCompare(b.country)
      );

      // Extract unique currencies
      const uniqueCurrencies = [];
      const currencyMap = new Map();

      sortedCountries.forEach((country) => {
        if (country.code && !currencyMap.has(country.code)) {
          currencyMap.set(country.code, true);
          uniqueCurrencies.push({
            code: country.code,
            symbol: country.symbol || country.code,
            name: country.currency || country.country || '',
            flag: country.flag || '',
            country: country.country || '',
          });
        }
      });

      // Sort currencies alphabetically by code
      uniqueCurrencies.sort((a, b) => a.code.localeCompare(b.code));
      setCurrencyOptions(uniqueCurrencies);
    }
  }, []);

  // Fetch DMCs for the dropdown
  const fetchDMCs = useCallback(async () => {
    if (!user?.cid) return;
    
    setLoadingDmcList(true);
    try {
      const apiUrl = `${config.GETCOMPANIES}?companyType=DMC&PageNumber=1&PageSize=100&parentCompanyId=${user.cid}`;
      const response = await apiService.getWithParams(apiUrl);
      
      if (response.data && Array.isArray(response.data)) {
        setDmcList(response.data);
      } else {
        setDmcList([]);
      }
    } catch (error) {
      console.error('Error fetching DMCs:', error);
      setDmcList([]);
    } finally {
      setLoadingDmcList(false);
    }
  }, [user]);

  // Call this when component mounts
  useEffect(() => {
    if (user) {
      fetchDMCs();
    }
  }, [user, fetchDMCs]);

  // Handle DMC selection
  const handleDmcSelect = (dmc) => {
    setSelectedDmc(dmc);
    
    if (dmc) {
      // Auto-fill contact information from selected DMC
      setFormData(prev => ({
        ...prev,
        ContactName: dmc.brandName || dmc.companyName || '',
        ContactEmail: dmc.email || '',
        ContactPhoneNumber: dmc.whatsAppNumber || '',
      }));
    } else {
      // Reset to user's contact info when no DMC selected
      setFormData(prev => ({
        ...prev,
        ContactName: user?.brandName || '',
        ContactEmail: user?.companyEmail || '',
        ContactPhoneNumber: user?.companyWhatsappnumber || '',
      }));
    }
  };

  const mainTabs = [
    { id: 'basic', label: '📋 Basic & Settings' },
    { id: 'itinerary', label: '📋 Itinerary' },
    { id: 'inclusions', label: '✅ Includes/Excludes& Terms&Conditions' },
  ];
  void mainTabs;

  // Sub-tabs for Inclusions
  const inclusionSubTabs = [
    { id: 'inclusions', label: '✅ Inclusions' },
    { id: 'exclusions', label: '❌ Exclusions' },
    { id: 'terms', label: '📄 Terms' },
  ];

  const [inclusionActiveSubTab, setInclusionActiveSubTab] = useState('inclusions');

  // Initialize formData with user data and default inclusions/exclusions/terms
  const [formData, setFormData] = useState({
    Title: '',
    Description: '',
    TravelType: '',
    HolidayType: 'HOLIDAY',
    HolidayKey: '',
    Duration: '',
    TotalNights: 3,
    TotalDays: 0,
    DestinationsCover: '',
    StartedDate: '',
    ValidityFrom: '',
    ValidityTo: '',
    NoOfPersons: 0,
    Adults: 0,
    Kids: 0,
    Infants: 0,
    Currency: 'INR',
    FlightPrice: 0,
    HotelPrice: 0,
    SightSeeingPrice: 0,
    TransferPrice: 0,
    OtherPrice: 0,
    PurchasePrice: 0,
    SalePrice: 0,
    ContactName: '',
    ContactPhoneNumber: '',
    ContactEmail: '',
    Inclusions: [
      'Accommodation in mentioned hotels',
      'Daily breakfast at hotels',
      'Airport transfers',
      'Sightseeing tours as per itinerary',
      'All taxes and service charges'
    ],
    Exclusions: [
      'International airfare',
      'Visa fees',
      'Travel insurance',
      'Personal expenses',
      'Meals not mentioned in itinerary'
    ],
    Terms: [
      { Title: 'Cancellation Policy', Description: 'Cancellations made 30 days prior to departure - 100% refund. 15-30 days - 50% refund. Less than 15 days - no refund.' },
      { Title: 'Payment Terms', Description: '50% advance payment required at the time of booking. Balance payment due 15 days before departure.' },
      { Title: 'Travel Insurance', Description: 'Travel insurance is mandatory for all travelers and must be arranged independently.' }
    ],
    Itinerary: [],
    Destinations: [],
    Status: 'Draft',
    ContentType: '',
    IsWebsite: false,
    IsLive: false,
  });

  // Update contact info when user loads
  useEffect(() => {
    if (user && !selectedDmc) {
      setFormData(prev => ({
        ...prev,
        ContactName: user?.brandName || '',
        ContactPhoneNumber: user?.companyWhatsappnumber || '',
        ContactEmail: user?.companyEmail || '',
      }));
    }
  }, [user, selectedDmc]);

  const travelTypes = [
    'Family',
    'Group',
    'Solo',
    'Honeymoon',
    'Leisure',
    'Business',
    'Adventure',
    'Pilgrimage',
    'Pilgrimage and Leisure Combo',
    'Luxury',
    'Budget',
  ];
  const statusOptions = ['Draft', 'Active','Inactive','Published', 'Archived'];

  // Price Sharing Handlers
  const handleAddPriceSharing = () => {
    const newItem = {
      Price: 0,
      SharingType: 'Double',
      AdultPrice: 0,
      KidPrice: 0,
      InfantPrice: 0
    };
    setPriceSharingItems([...priceSharingItems, newItem]);
  };

  const handleUpdatePriceSharing = (index, field, value) => {
    const updatedItems = [...priceSharingItems];
    updatedItems[index] = { ...updatedItems[index], [field]: value };
    setPriceSharingItems(updatedItems);
  };

  const handleRemovePriceSharing = (index) => {
    setPriceSharingItems(priceSharingItems.filter((_, i) => i !== index));
  };

  // Destination suggestion handler
  const handleDestinationInputChange = (e) => {
    const value = e.target.value;
    setDestinationInput(value);

    if (value.trim().length > 0) {
      const filtered = destinationData.filter(dest =>
        dest.Destination.toLowerCase().includes(value.toLowerCase())
      );
      setDestinationSuggestions(filtered);
      setShowSuggestions(true);
    } else {
      setDestinationSuggestions([]);
      setShowSuggestions(false);
    }
  };

  // Select all places from a destination
  const handleSelectDestination = (destination) => {
    const newPlaces = destination.Places.map(place => ({
      place: place,
      destination: destination.Destination
    }));

    // Add only places that aren't already selected
    const uniqueNewPlaces = newPlaces.filter(
      p => !selectedPlaces.some(existing => existing.place === p.place)
    );

    if (uniqueNewPlaces.length > 0) {
      const updatedPlaces = [...selectedPlaces, ...uniqueNewPlaces];
      setSelectedPlaces(updatedPlaces);

      // Update DestinationsCover with just place names (not destination names)
      const placeNames = updatedPlaces.map(p => p.place).join(', ');
      setFormData(prev => ({
        ...prev,
        DestinationsCover: placeNames
      }));

      // Store selected destinations for reference (but not for DestinationsCover)
      if (!selectedDestinations.find(d => d.Destination === destination.Destination)) {
        setSelectedDestinations([...selectedDestinations, destination]);
      }

      setCurrentDestination(destination);
      setShowPlaceDropdown(true);
    }

    setDestinationInput('');
    setDestinationSuggestions([]);
    setShowSuggestions(false);
  };

  // Remove entire destination and its places
  const handleRemoveSelectedDestination = (destinationToRemove) => {
    const updated = selectedDestinations.filter(d => d.Destination !== destinationToRemove.Destination);
    setSelectedDestinations(updated);

    // Remove places associated with this destination
    const updatedPlaces = selectedPlaces.filter(p => p.destination !== destinationToRemove.Destination);
    setSelectedPlaces(updatedPlaces);

    // Update DestinationsCover with just place names (not destination names)
    const placeNames = updatedPlaces.map(p => p.place).join(', ');
    setFormData(prev => ({
      ...prev,
      DestinationsCover: placeNames
    }));

    if (currentDestination?.Destination === destinationToRemove.Destination) {
      setCurrentDestination(null);
      setShowPlaceDropdown(false);
    }
  };
  void handleRemoveSelectedDestination;

  // Toggle individual place selection
  const handleTogglePlace = (place) => {
    const placeObj = {
      place: place,
      destination: currentDestination.Destination
    };

    let updatedPlaces;
    const exists = selectedPlaces.some(p => p.place === place && p.destination === currentDestination.Destination);

    if (exists) {
      updatedPlaces = selectedPlaces.filter(p => !(p.place === place && p.destination === currentDestination.Destination));
    } else {
      updatedPlaces = [...selectedPlaces, placeObj];
    }

    setSelectedPlaces(updatedPlaces);

    // Update DestinationsCover with just place names
    const placeNames = updatedPlaces.map(p => p.place).join(', ');
    setFormData(prev => ({
      ...prev,
      DestinationsCover: placeNames
    }));
  };

  // Remove individual place
  const handleRemoveSelectedPlace = (placeToRemove) => {
    const updatedPlaces = selectedPlaces.filter(p => !(p.place === placeToRemove.place && p.destination === placeToRemove.destination));
    setSelectedPlaces(updatedPlaces);

    // Update DestinationsCover with just place names
    const placeNames = updatedPlaces.map(p => p.place).join(', ');
    setFormData(prev => ({
      ...prev,
      DestinationsCover: placeNames
    }));
  };

  // Manual place entry
  const handleManualPlaceAdd = () => {
    const input = document.getElementById('manualPlaceInput');
    const placeName = input?.value?.trim();

    if (placeName) {
      // Check if already exists
      if (!selectedPlaces.some(p => p.place === placeName)) {
        const placeObj = {
          place: placeName,
          destination: 'Manual Entry'
        };

        const updatedPlaces = [...selectedPlaces, placeObj];
        setSelectedPlaces(updatedPlaces);

        // Update DestinationsCover with just place names
        const placeNames = updatedPlaces.map(p => p.place).join(', ');
        setFormData(prev => ({
          ...prev,
          DestinationsCover: placeNames
        }));

        // Also add to selectedDestinations for reference
        if (!selectedDestinations.find(d => d.Destination === 'Manual Entry')) {
          setSelectedDestinations([...selectedDestinations, { Destination: 'Manual Entry', Places: [placeName] }]);
        }
      }

      input.value = '';
    }
  };

  const isPlaceSelected = (place) => {
    return selectedPlaces.some(p => p.place === place && p.destination === currentDestination?.Destination);
  };

  // AI Package Generation Handler
  const handleGenerateWithAIClick = async () => {
    setIsCheckingConnects(true);

    try {
      const updatedProfile = await refreshUserProfile();

      if (updatedProfile && updatedProfile.connects > 0) {
        setShowPackageTypeSelectionModal(true);
      } else {
        setShowNoConnectsModal(true);
      }
    } catch (error) {
      setToast({ message: "Could not verify your connects balance. Please try again.", type: 'error' });
      console.error("Error checking connects:", error);
    } finally {
      setIsCheckingConnects(false);
    }
  };

  // Navigation handlers for AI package types
  const handleNavigateToFlightPackage = () => {
    setShowPackageTypeSelectionModal(false);
    navigate("/flight-ai-packagecreate");
  };

  const handleNavigateToLandPackage = () => {
    setShowPackageTypeSelectionModal(false);
    navigate("/land-ai-packagecreate");
  };

  // Effect for auto-generation of Holiday Key
  useEffect(() => {
    if (formData.DestinationsCover && formData.TotalNights > 0) {
      const destShort = formData.DestinationsCover.split(',')[0].trim().substring(0, 3).toUpperCase();
      const currentDate = new Date();
      const year = currentDate.getFullYear().toString().slice(-2);
      const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
      const day = currentDate.getDate().toString().padStart(2, '0');
      const holidayKey = `${destShort}${formData.TotalNights}N${year}${month}${day}`;

      if (!formData.HolidayKey || formData.HolidayKey === '') {
        setFormData(prev => ({ ...prev, HolidayKey: holidayKey }));
      }
    }
  }, [formData.DestinationsCover, formData.TotalNights]);

  // Effect for auto-calculation of Total Days and Duration from Total Nights
  useEffect(() => {
    if (formData.TotalNights > 0) {
      const days = formData.TotalNights + 1;
      const durationLabel = `${days}D/${formData.TotalNights}N`;
      setFormData(prev => ({
        ...prev,
        TotalDays: days,
        Duration: durationLabel
      }));
    } else if (formData.TotalNights === 0) {
      const days = 1;
      const durationLabel = `${days}D/0N`;
      setFormData(prev => ({
        ...prev,
        TotalDays: days,
        Duration: durationLabel
      }));
    }
  }, [formData.TotalNights]);

  // Effect for auto-calculation of Total Persons
  useEffect(() => {
    const total = (formData.Adults || 0) + (formData.Kids || 0) + (formData.Infants || 0);
    setFormData(prev => ({
      ...prev,
      NoOfPersons: total
    }));
  }, [formData.Adults, formData.Kids, formData.Infants]);

  // Handle manual days/nights change - auto-calculate duration
  const handleDaysNightsChange = (field, value) => {
    const numValue = parseInt(value) || 0;
    setFormData(prev => {
      const newData = { ...prev, [field]: numValue };
      const days = field === 'TotalDays' ? numValue : prev.TotalDays;
      const nights = field === 'TotalNights' ? numValue : prev.TotalNights;
      if (days > 0 || nights > 0) {
        const durationLabel = `${days}D/${nights}N`;
        newData.Duration = durationLabel;
      }
      return newData;
    });
  };

  // Handle form input change
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : type === 'number' ? parseFloat(value) || 0 : value
    }));
  };

  // Handle file upload
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  // Array handlers
  const handleAddArrayItem = (field, value) => {
    if (!value.trim()) return;
    setFormData(prev => ({ ...prev, [field]: [...prev[field], value.trim()] }));
  };

  const handleRemoveArrayItem = (field, index) => {
    setFormData(prev => ({ ...prev, [field]: prev[field].filter((_, i) => i !== index) }));
  };

  // Terms handlers
  const handleAddTerm = () => {
    const title = document.getElementById('termTitle')?.value;
    const description = document.getElementById('termDescription')?.value;
    if (title?.trim()) {
      setFormData(prev => ({
        ...prev,
        Terms: [...prev.Terms, { Title: title.trim(), Description: description?.trim() || '' }]
      }));
      document.getElementById('termTitle').value = '';
      document.getElementById('termDescription').value = '';
    }
  };

  const handleRemoveTerm = (index) => {
    setFormData(prev => ({ ...prev, Terms: prev.Terms.filter((_, i) => i !== index) }));
  };

  // Itinerary handlers
  const handleAddItineraryDay = () => {
    setFormData(prev => ({
      ...prev,
      Itinerary: [
        ...prev.Itinerary,
        {
          Day: prev.Itinerary.length + 1,
          Title: '',
          Description: '',
          Location: '',
          Meals: '',
          Note: '',
          Date: '',
          Flights: [],
          Hotels: [],
          Sightseeing: [],
          Transfers: []
        }
      ]
    }));
  };

  const handleItineraryChange = (index, field, value) => {
    setFormData(prev => {
      const newItinerary = [...prev.Itinerary];
      newItinerary[index] = { ...newItinerary[index], [field]: value };
      return { ...prev, Itinerary: newItinerary };
    });
  };

  const handleRemoveItineraryDay = (index) => {
    setFormData(prev => ({ ...prev, Itinerary: prev.Itinerary.filter((_, i) => i !== index) }));
  };

  // Flight handlers
  const handleAddFlight = (dayIndex) => {
    setFormData(prev => {
      const newItinerary = [...prev.Itinerary];
      newItinerary[dayIndex].Flights.push({
        PackageFlightBookingId: 'new-' + Date.now(),
        Airline: '',
        FlightNumber: '',
        DepartureCity: '',
        ArrivalCity: '',
        DepartureDateTime: '',
        ArrivalDateTime: '',
        CabinClass: '',
        JourneyType: '',
        Adults: 0,
        Kids: 0,
        Infants: 0,
        Baggage: '',
        OptionId: '',
        IsIncluded: true,
        Price: 0,
        Segments: []
      });
      return { ...prev, Itinerary: newItinerary };
    });
  };

  const handleUpdateFlight = (dayIndex, flightIndex, updatedFlight) => {
    setFormData(prev => {
      const newItinerary = [...prev.Itinerary];
      newItinerary[dayIndex].Flights[flightIndex] = updatedFlight;
      return { ...prev, Itinerary: newItinerary };
    });
  };

  const handleRemoveFlight = (dayIndex, flightIndex) => {
    setFormData(prev => {
      const newItinerary = [...prev.Itinerary];
      newItinerary[dayIndex].Flights.splice(flightIndex, 1);
      return { ...prev, Itinerary: newItinerary };
    });
  };

  // Hotel handlers
  const handleAddHotel = (dayIndex) => {
    setFormData(prev => {
      const newItinerary = [...prev.Itinerary];
      newItinerary[dayIndex].Hotels.push({
        PackageHotelBookingId: 'new-' + Date.now(),
        HotelName: '',
        City: '',
        StarRating: 0,
        RoomType: '',
        MealPlan: '',
        NumberOfRooms: 1,
        Nights: 0,
        CheckInDate: '',
        CheckOutDate: '',
        IsIncluded: true,
        Price: 0
      });
      return { ...prev, Itinerary: newItinerary };
    });
  };

  const handleUpdateHotel = (dayIndex, hotelIndex, updatedHotel) => {
    setFormData(prev => {
      const newItinerary = [...prev.Itinerary];
      newItinerary[dayIndex].Hotels[hotelIndex] = updatedHotel;
      return { ...prev, Itinerary: newItinerary };
    });
  };

  const handleRemoveHotel = (dayIndex, hotelIndex) => {
    setFormData(prev => {
      const newItinerary = [...prev.Itinerary];
      newItinerary[dayIndex].Hotels.splice(hotelIndex, 1);
      return { ...prev, Itinerary: newItinerary };
    });
  };

  // Sightseeing handlers
  const handleAddSightseeing = (dayIndex) => {
    setFormData(prev => {
      const newItinerary = [...prev.Itinerary];
      newItinerary[dayIndex].Sightseeing.push({
        PackageSightSeeingId: 'new-' + Date.now(),
        SightseeingName: '',
        Destination: '',
        Description: '',
        Duration: '',
        Type: '',
        Date: '',
        IsIncluded: true,
        Price: 0
      });
      return { ...prev, Itinerary: newItinerary };
    });
  };

  const handleUpdateSightseeing = (dayIndex, ssIndex, updatedSightseeing) => {
    setFormData(prev => {
      const newItinerary = [...prev.Itinerary];
      newItinerary[dayIndex].Sightseeing[ssIndex] = updatedSightseeing;
      return { ...prev, Itinerary: newItinerary };
    });
  };

  const handleRemoveSightseeing = (dayIndex, ssIndex) => {
    setFormData(prev => {
      const newItinerary = [...prev.Itinerary];
      newItinerary[dayIndex].Sightseeing.splice(ssIndex, 1);
      return { ...prev, Itinerary: newItinerary };
    });
  };

  // Transfer handlers
  const handleAddTransfer = (dayIndex) => {
    setFormData(prev => {
      const newItinerary = [...prev.Itinerary];
      newItinerary[dayIndex].Transfers.push({
        PackageTransferId: 'new-' + Date.now(),
        FromLocation: '',
        ToLocation: '',
        VehicleDetails: '',
        Type: '',
        PickupTime: '',
        Date: '',
        IsIncluded: true,
        Price: 0
      });
      return { ...prev, Itinerary: newItinerary };
    });
  };

  const handleUpdateTransfer = (dayIndex, transferIndex, updatedTransfer) => {
    setFormData(prev => {
      const newItinerary = [...prev.Itinerary];
      newItinerary[dayIndex].Transfers[transferIndex] = updatedTransfer;
      return { ...prev, Itinerary: newItinerary };
    });
  };

  const handleRemoveTransfer = (dayIndex, transferIndex) => {
    setFormData(prev => {
      const newItinerary = [...prev.Itinerary];
      newItinerary[dayIndex].Transfers.splice(transferIndex, 1);
      return { ...prev, Itinerary: newItinerary };
    });
  };

  // Validate form
  const validateForm = () => {
    const required = ['Title', 'Description', 'TotalDays', 'TotalNights', 'DestinationsCover', 'SalePrice'];
    for (const field of required) {
      if (!formData[field] || (typeof formData[field] === 'string' && !formData[field].trim())) {
        setToast({ message: `Please fill in "${field}"`, type: 'error' });
        return false;
      }
    }
    if (formData.TotalDays <= 0) {
      setToast({ message: 'Total Days must be greater than 0', type: 'error' });
      return false;
    }
    if (formData.SalePrice <= 0) {
      setToast({ message: 'Sale Price must be greater than 0', type: 'error' });
      return false;
    }
    return true;
  };

  // Generate PDF/Print - Open in new tab
  const handlePrint = () => {
    sessionStorage.setItem('previewData', JSON.stringify({
      formData,
      imagePreview,
      currencyOptions: currencyOptions,
      priceSharingItems: priceSharingItems
    }));
    window.open('/package-preview?print=true', '_blank');
  };

  // Preview in new tab
  const handlePreview = () => {
    sessionStorage.setItem('previewData', JSON.stringify({
      formData,
      imagePreview,
      currencyOptions: currencyOptions,
      priceSharingItems: priceSharingItems
    }));
    window.open('/package-preview', '_blank');
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;
    if (!user?.cid) {
      setToast({ message: 'Company ID not found. Please login again.', type: 'error' });
      return;
    }

    setIsLoading(true);

    try {
      const submitData = new FormData();

      // ==========================================
      // AUTO-COMPILE DESTINATIONS FROM ITINERARY
      // ==========================================
      const compiledDestinations = [];
      const cityMap = new Map();
      let sequenceNum = 1;

      (formData.Itinerary || []).forEach(day => {
        (day.Hotels || []).forEach(hotel => {
          const cityName = hotel.City || day.Location || "Unknown";
          const normalizedCity = cityName.trim().toLowerCase();

          if (!cityMap.has(normalizedCity)) {
            const placeObj = {
              CityCode: hotel.City?.substring(0, 3).toUpperCase() || "CTY",
              CityName: cityName,
              Nights: parseInt(hotel.Nights) || 1,
              Sequence: sequenceNum++,
              Hotels: [
                {
                  HotelId: hotel.PackageHotelBookingId && !hotel.PackageHotelBookingId.startsWith('new-')
                    ? hotel.PackageHotelBookingId
                    : generateGuid(),
                  HotelName: hotel.HotelName || "Suggested Hotel",
                  RoomType: hotel.RoomType || "",
                  MealPlan: hotel.MealPlan || "",
                  StarRating: parseInt(hotel.StarRating) || 0
                }
              ]
            };
            cityMap.set(normalizedCity, placeObj);
          } else {
            const existingPlace = cityMap.get(normalizedCity);
            existingPlace.Nights += (parseInt(hotel.Nights) || 0);

            const hotelExists = existingPlace.Hotels.some(h => h.HotelName === hotel.HotelName);
            if (!hotelExists) {
              existingPlace.Hotels.push({
                HotelId: hotel.PackageHotelBookingId && !hotel.PackageHotelBookingId.startsWith('new-')
                  ? hotel.PackageHotelBookingId
                  : generateGuid(),
                HotelName: hotel.HotelName || "Suggested Hotel",
                RoomType: hotel.RoomType || "",
                MealPlan: hotel.MealPlan || "",
                StarRating: parseInt(hotel.StarRating) || 0
              });
            }
          }
        });
      });

      const placesList = Array.from(cityMap.values());
      if (placesList.length > 0) {
        const primaryCountry = formData.DestinationsCover?.split(',')[0]?.trim() || "Destination";
        compiledDestinations.push({
          CountryCode: "IN",
          CountryName: primaryCountry,
          Places: placesList
        });
      }

      // 1. Build the payload object with all fields
      const submitPayload = {
        Title: formData.Title,
        Description: formData.Description,
        TravelType: formData.TravelType,
        HolidayType: 'Holiday',
        HolidayKey: formData.HolidayKey,
        Duration: formData.Duration,
        TotalNights: formData.TotalNights,
        TotalDays: formData.TotalDays,
        DestinationsCover: formData.DestinationsCover,
        NoOfPersons: formData.NoOfPersons,
        Adults: formData.Adults,
        Kids: formData.Kids,
        Infants: formData.Infants,
        Currency: formData.Currency,
        FlightPrice: formData.FlightPrice,
        HotelPrice: formData.HotelPrice,
        SightSeeingPrice: formData.SightSeeingPrice,
        TransferPrice: formData.TransferPrice,
        OtherPrice: formData.OtherPrice,
        PurchasePrice: formData.PurchasePrice,
        SalePrice: formData.SalePrice,
        ContactName: formData.ContactName,
        ContactPhoneNumber: formData.ContactPhoneNumber,
        ContactEmail: formData.ContactEmail,
        Status: formData.Status,
        IsWebsite: formData.IsWebsite,
        IsLive: formData.IsLive,
        // DMC-specific fields
        CompanyId: selectedDmc ? selectedDmc.companyId : user?.cid,
        Source: selectedDmc ? "Dmc" : "Manual",
        UserId: selectedDmc ? selectedDmc.userId : (user?.id || ''),
        CreatedBy: selectedDmc 
          ? (selectedDmc.brandName || selectedDmc.companyName || '') 
          : (user?.name || user?.email || ''),
        CompanyName: selectedDmc 
          ? (selectedDmc.companyName || '') 
          : (user?.companyname || ''),
        StartedDate: formData.StartedDate ? new Date(formData.StartedDate).toISOString() : null,
        Validity: formData.ValidityFrom && formData.ValidityTo ? {
          From: new Date(formData.ValidityFrom).toISOString(),
          To: new Date(formData.ValidityTo).toISOString()
        } : null,
        Inclusions: formData.Inclusions,
        Exclusions: formData.Exclusions,
        Terms: formData.Terms,
        Destinations: compiledDestinations.length > 0 ? compiledDestinations : null,
        PriceSharing: priceSharingItems
      };

      // 2. Map and append itinerary details safely
      if (formData.Itinerary?.length > 0) {
        submitPayload.Itinerary = formData.Itinerary.map(day => ({
          Day: day.Day || 0,
          Title: day.Title || '',
          Description: day.Description || '',
          Location: day.Location || '',
          Meals: day.Meals || '',
          Note: day.Note || '',
          Date: day.Date || '',
          Flights: day.Flights?.map(f => ({
            PackageFlightBookingId: f.PackageFlightBookingId && !f.PackageFlightBookingId.startsWith('new-')
              ? f.PackageFlightBookingId
              : generateGuid(),
            Airline: f.Airline || '',
            FlightNumber: f.FlightNumber || '',
            DepartureCity: f.DepartureCity || '',
            ArrivalCity: f.ArrivalCity || '',
            DepartureDateTime: f.DepartureDateTime || '',
            ArrivalDateTime: f.ArrivalDateTime || '',
            CabinClass: f.CabinClass || '',
            JourneyType: f.JourneyType || '',
            Adults: f.Adults || 0,
            Kids: f.Kids || 0,
            Infants: f.Infants || 0,
            Baggage: f.Baggage || '',
            OptionId: f.OptionId || '',
            IsIncluded: f.IsIncluded !== undefined ? f.IsIncluded : true,
            Price: f.Price || 0,
            Segments: f.Segments?.map(s => ({
              From: s.From || '',
              To: s.To || '',
              Airline: s.Airline || '',
              FlightNo: s.FlightNo || '',
              DepartureTime: s.DepartureTime || '',
              ArrivalTime: s.ArrivalTime || ''
            })) || []
          })) || [],
          Hotels: day.Hotels?.map(h => ({
            PackageHotelBookingId: h.PackageHotelBookingId && !h.PackageHotelBookingId.startsWith('new-')
              ? h.PackageHotelBookingId
              : generateGuid(),
            HotelName: h.HotelName || '',
            City: h.City || '',
            StarRating: h.StarRating || 0,
            RoomType: h.RoomType || '',
            MealPlan: h.MealPlan || '',
            NumberOfRooms: h.NumberOfRooms || 1,
            Nights: h.Nights || 0,
            CheckInDate: h.CheckInDate || '',
            CheckOutDate: h.CheckOutDate || '',
            IsIncluded: h.IsIncluded !== undefined ? h.IsIncluded : true,
            Price: h.Price || 0
          })) || [],
          Sightseeing: day.Sightseeing?.map(s => ({
            PackageSightSeeingId: s.PackageSightSeeingId && !s.PackageSightSeeingId.startsWith('new-')
              ? s.PackageSightSeeingId
              : generateGuid(),
            SightseeingName: s.SightseeingName || '',
            Destination: s.Destination || '',
            Description: s.Description || '',
            Duration: s.Duration || '',
            Type: s.Type || '',
            Date: s.Date || '',
            IsIncluded: s.IsIncluded !== undefined ? s.IsIncluded : true,
            Price: s.Price || 0
          })) || [],
          Transfers: day.Transfers?.map(t => ({
            PackageTransferId: t.PackageTransferId && !t.PackageTransferId.startsWith('new-')
              ? t.PackageTransferId
              : generateGuid(),
            FromLocation: t.FromLocation || '',
            ToLocation: t.ToLocation || '',
            VehicleDetails: t.VehicleDetails || '',
            Type: t.Type || '',
            PickupTime: t.PickupTime || '',
            Date: t.Date || '',
            IsIncluded: t.IsIncluded !== undefined ? t.IsIncluded : true,
            Price: t.Price || 0
          })) || []
        }));
      }

      // 3. Helper function to compile nested arrays/objects into FormData keys
      const appendFormDataHelper = (form, data, parentKey = '') => {
        if (data === null || data === undefined) return;

        if (data instanceof File) {
          form.append(parentKey, data);
        } else if (Array.isArray(data)) {
          data.forEach((item, index) => {
            appendFormDataHelper(form, item, `${parentKey}[${index}]`);
          });
        } else if (typeof data === 'object') {
          Object.keys(data).forEach(key => {
            appendFormDataHelper(form, data[key], parentKey ? `${parentKey}.${key}` : key);
          });
        } else {
          form.append(parentKey, data);
        }
      };

      // 4. Run helper over payload to append everything seamlessly
      Object.keys(submitPayload).forEach(key => {
        appendFormDataHelper(submitData, submitPayload[key], key);
      });

      // 5. Append file separately if selected
      if (selectedFile) {
        submitData.append('ImageFile', selectedFile);
        submitData.append('ImageName', selectedFile.name);
      }

      const response = await apiService.post(
        config.CREATEPACKAGE,
        submitData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response?.success || response?.succeeded || response?.packageId) {
        setToast({ message: 'Package created successfully! 🎉', type: 'success' });
        setTimeout(() => navigate('/packageslist'), 2000);
      } else {
        throw new Error(response?.message || 'Failed to create package');
      }
    } catch (error) {
      console.error('Error creating package:', error);
      setToast({ message: error.message || 'Failed to create package. Please try again.', type: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  // Step navigation
  const goToStep = (stepId) => setCurrentStep(stepId);
  const goNext = () => setCurrentStep(s => Math.min(6, s + 1));
  const goBack = () => setCurrentStep(s => Math.max(1, s - 1));

  const isStepComplete = (stepId) => {
    switch (stepId) {
      case 1: return Boolean(formData.Title.trim() && formData.Description.trim());
      case 2: return Boolean(formData.DestinationsCover.trim());
      case 3: return Boolean(formData.SalePrice > 0);
      case 4: return Boolean(formData.Status);
      case 5: return formData.Itinerary.length > 0;
      case 6: return formData.Inclusions.length > 0 || formData.Exclusions.length > 0 || formData.Terms.length > 0;
      default: return false;
    }
  };

  const margin = (formData.SalePrice || 0) - (formData.PurchasePrice || 0);

  // Step 1 — Basic Info
  const renderStep1 = () => (
    <div>
      <h2 className="pkg-step-title">Basic Info</h2>
      <p className="pkg-step-subtitle">Give your package a name, description, and a cover image travelers will see first.</p>

      <div className="pkg-dropzone-row">
        <div>
          {/* DMC Selection - New Section */}
          <div className="pkg-form-group">
            <label className="pkg-label">Select DMC (Optional)</label>
            <select 
              className="pkg-select" 
              value={selectedDmc?.companyId || ''} 
              onChange={(e) => {
                const dmc = dmcList.find(d => d.companyId === e.target.value);
                handleDmcSelect(dmc || null);
              }}
            >
              <option value="">-- Select DMC --</option>
              {dmcList.map(dmc => (
                <option key={dmc.companyId} value={dmc.companyId}>
                  {dmc.companyName} {dmc.brandName ? `(${dmc.brandName})` : ''}
                </option>
              ))}
            </select>
            {loadingDmcList && <span className="pkg-hint">Loading DMCs...</span>}
            <span className="pkg-hint">Select a DMC to create this package on their behalf, or leave empty to create for yourself.</span>
          </div>

          <div className="pkg-form-group">
            <label className="pkg-label">Package Title <span className="pkg-required">*</span></label>
            <input
              className="pkg-input"
              name="Title"
              value={formData.Title}
              onChange={handleInputChange}
              placeholder="e.g., Magical Bali Getaway"
              required
            />
          </div>
          <div className="pkg-form-group">
            <label className="pkg-label">Description <span className="pkg-required">*</span></label>
            <textarea
              className="pkg-textarea"
              name="Description"
              value={formData.Description}
              onChange={handleInputChange}
              rows={4}
              placeholder="Describe what makes this package special..."
              required
            />
          </div>
        </div>

        <div className="pkg-dropzone">
          <div className="pkg-dropzone-preview">
            <img src={imagePreview || DEFAULT_IMAGE} alt="Package cover" />
            {imagePreview && (
              <button
                className="pkg-dropzone-remove"
                onClick={() => { setSelectedFile(null); setImagePreview(null); }}
                type="button"
                title="Remove image"
              >×</button>
            )}
          </div>
          <button className="pkg-upload-btn" onClick={() => fileInputRef.current?.click()} type="button">
            <input type="file" ref={fileInputRef} style={{ display: 'none' }} accept="image/*" onChange={handleFileChange} />
            {imagePreview ? 'Change Cover Image' : 'Upload Cover Image'}
          </button>
          <span className="pkg-upload-hint">JPG or PNG recommended</span>
        </div>
      </div>
    </div>
  );

  // Step 2 — Destinations & Travelers
  const renderStep2 = () => (
    <div>
      <h2 className="pkg-step-title">Destinations &amp; Travelers</h2>
      <p className="pkg-step-subtitle">Search for the places covered by this package, then set travel type and traveler counts.</p>

      <div className="pkg-form-group">
        <label className="pkg-label">Destinations Covered (Places) <span className="pkg-required">*</span></label>
        <div className="pkg-destination-search">
          <input
            className="pkg-input"
            value={destinationInput}
            onChange={handleDestinationInputChange}
            onFocus={() => destinationInput.trim().length > 0 && setShowSuggestions(true)}
            placeholder="Search for destinations to add places..."
          />
          {showSuggestions && destinationSuggestions.length > 0 && (
            <div className="pkg-suggestions">
              {destinationSuggestions.map((dest, idx) => (
                <div
                  key={idx}
                  className="pkg-suggestion-item"
                  onClick={() => handleSelectDestination(dest)}
                >
                  <span>{dest.Destination}</span>
                  <span className="pkg-suggestion-place">
                    {dest.Places.slice(0, 3).join(', ')}{dest.Places.length > 3 ? '...' : ''}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="pkg-manual-add">
          <input
            className="pkg-input"
            id="manualPlaceInput"
            placeholder="Add place manually (e.g., Delhi, Mumbai)..."
            onKeyPress={(e) => { if (e.key === 'Enter') { handleManualPlaceAdd(); } }}
          />
          <button className="pkg-btn pkg-btn-secondary" type="button" onClick={handleManualPlaceAdd}>
            + Add Place
          </button>
        </div>

        <div className="pkg-pills">
          {selectedPlaces.map((p, idx) => (
            <span key={idx} className="pkg-pill">
              📍 {p.place}
              {p.destination !== 'Manual Entry' && ` (${p.destination})`}
              <span className="pkg-pill-remove" onClick={() => handleRemoveSelectedPlace(p)}>×</span>
            </span>
          ))}
          {selectedPlaces.length === 0 && (
            <span className="pkg-empty-hint">No places added yet. Search or enter manually.</span>
          )}
        </div>
        <input type="hidden" name="DestinationsCover" value={formData.DestinationsCover} readOnly />
      </div>

      {showPlaceDropdown && currentDestination && (
        <div className="pkg-place-panel">
          <div className="pkg-place-panel-header">
            <label className="pkg-label" style={{ margin: 0 }}>Select Places for {currentDestination.Destination}</label>
            <button className="pkg-btn-remove" onClick={() => setShowPlaceDropdown(false)} type="button">Close</button>
          </div>
          <div className="pkg-place-chips">
            {currentDestination.Places.map((place, idx) => (
              <span
                key={idx}
                className={`pkg-place-chip ${isPlaceSelected(place) ? 'selected' : ''}`}
                onClick={() => handleTogglePlace(place)}
              >
                {place}{isPlaceSelected(place) && ' ✓'}
              </span>
            ))}
          </div>
        </div>
      )}

      <div className="pkg-grid-auto" style={{ marginTop: '20px' }}>
        <div className="pkg-form-group">
          <label className="pkg-label">Travel Type</label>
          <select className="pkg-select" name="TravelType" value={formData.TravelType} onChange={handleInputChange}>
            <option value="">Select</option>
            {travelTypes.map(type => <option key={type} value={type}>{type}</option>)}
          </select>
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Total Nights</label>
          <input
            type="number"
            className="pkg-input"
            name="TotalNights"
            value={formData.TotalNights}
            onChange={(e) => handleDaysNightsChange('TotalNights', e.target.value)}
            min="0"
            placeholder="Nights"
          />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Adults</label>
          <input type="number" className="pkg-input" name="Adults" value={formData.Adults} onChange={handleInputChange} min="0" />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Kids</label>
          <input type="number" className="pkg-input" name="Kids" value={formData.Kids} onChange={handleInputChange} min="0" />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Infants</label>
          <input type="number" className="pkg-input" name="Infants" value={formData.Infants} onChange={handleInputChange} min="0" />
        </div>
        <div className="pkg-form-group">
          <label className="pkg-label">Total Persons</label>
          <input type="number" className="pkg-input" name="NoOfPersons" value={formData.NoOfPersons} disabled readOnly />
        </div>
      </div>
    </div>
  );

  // Step 3 — Dates & Pricing
  const renderStep3 = () => (
    <div>
      <h2 className="pkg-step-title">Dates &amp; Pricing</h2>
      <p className="pkg-step-subtitle">Set the travel window, currency, and how this package is priced.</p>

      <div className="pkg-section">
        <div className="pkg-section-heading">📅 Dates</div>
        <div className="pkg-grid-3">
          <div className="pkg-form-group">
            <label className="pkg-label">Start Date</label>
            <input type="date" className="pkg-input" name="StartedDate" value={formData.StartedDate} onChange={handleInputChange} />
          </div>
          <div className="pkg-form-group">
            <label className="pkg-label">Validity From</label>
            <input type="date" className="pkg-input" name="ValidityFrom" value={formData.ValidityFrom} onChange={handleInputChange} />
          </div>
          <div className="pkg-form-group">
            <label className="pkg-label">Validity To</label>
            <input type="date" className="pkg-input" name="ValidityTo" value={formData.ValidityTo} onChange={handleInputChange} />
          </div>
        </div>
      </div>

      <div className="pkg-section">
        <div className="pkg-section-heading">💰 Pricing</div>
        <div className="pkg-grid-3">
          <div className="pkg-form-group">
            <label className="pkg-label">Currency</label>
            <select className="pkg-select" name="Currency" value={formData.Currency} onChange={handleInputChange}>
              <option value="">Select Currency</option>
              {currencyOptions.map((currency) => (
                <option key={currency.code} value={currency.code}>
                  {currency.code} - {currency.name}
                </option>
              ))}
            </select>
          </div>
          <div className="pkg-form-group">
            <label className="pkg-label">No of Persons</label>
            <input
              type="number"
              className="pkg-input"
              name="NoOfPersons"
              value={formData.NoOfPersons}
              onChange={handleInputChange}
              min="1"
              placeholder="Total persons"
            />
          </div>
          <div className="pkg-form-group">
            <label className="pkg-label">Sale Price <span className="pkg-required">*</span></label>
            <input
              type="number"
              className="pkg-input"
              name="SalePrice"
              value={formData.SalePrice}
              onChange={handleInputChange}
              min="0"
              step="0.01"
              placeholder="0.00"
              required
            />
          </div>
        </div>

        <div className="pkg-margin-strip">
          <div className="pkg-margin-item">
            <span>Purchase Price</span>
            <span className="pkg-margin-value">{formData.Currency} {(formData.PurchasePrice || 0).toFixed(2)}</span>
          </div>
          <div className="pkg-margin-item">
            <span>Sale Price</span>
            <span className="pkg-margin-value">{formData.Currency} {(formData.SalePrice || 0).toFixed(2)}</span>
          </div>
          <div className="pkg-margin-item">
            <span>Profit Margin</span>
            <span className={`pkg-margin-value ${margin > 0 ? 'positive' : margin < 0 ? 'negative' : ''}`}>
              {formData.Currency} {margin.toFixed(2)}
            </span>
          </div>
        </div>

        <div className="pkg-section">
          <div className="pkg-section-heading" style={{ display: 'flex', justifyContent: 'space-between', border: 'none', paddingBottom: 0 }}>
            <span>👥 Price Sharing</span>
            <button className="pkg-btn pkg-btn-xs pkg-btn-secondary" type="button" onClick={handleAddPriceSharing}>
              + Add Price Tier
            </button>
          </div>

          {priceSharingItems.length === 0 ? (
            <p className="pkg-empty-hint" style={{ padding: '8px 0' }}>
              No price sharing tiers added. Click "Add Price Tier" to configure.
            </p>
          ) : (
            priceSharingItems.map((item, index) => (
              <div key={index} className="pkg-subcard-tier">
                <div className="pkg-subcard-header">
                  <strong>Price Tier {index + 1}</strong>
                  <button className="pkg-btn-remove" onClick={() => handleRemovePriceSharing(index)} type="button">Remove</button>
                </div>
                <div className="pkg-grid-4">
                  <div className="pkg-form-group">
                    <label className="pkg-label">Price</label>
                    <input type="number" className="pkg-input" value={item.Price || 0} onChange={(e) => handleUpdatePriceSharing(index, 'Price', parseFloat(e.target.value) || 0)} min="0" step="0.01" placeholder="0.00" />
                  </div>
                  <div className="pkg-form-group">
                    <label className="pkg-label">Sharing Type</label>
                    <select className="pkg-select" value={item.SharingType || 'Double'} onChange={(e) => handleUpdatePriceSharing(index, 'SharingType', e.target.value)}>
                      <option value="Double">Double</option>
                      <option value="Single">Single</option>
                      <option value="Triple">Triple</option>
                      <option value="Quad">Quad</option>
                      <option value="Child with Bed">Child with Bed</option>
                      <option value="Child without Bed">Child without Bed</option>
                      <option value="Infant">Infant</option>
                    </select>
                  </div>
                  <div className="pkg-form-group">
                    <label className="pkg-label">Adult Price</label>
                    <input type="number" className="pkg-input" value={item.AdultPrice || 0} onChange={(e) => handleUpdatePriceSharing(index, 'AdultPrice', parseFloat(e.target.value) || 0)} min="0" step="0.01" placeholder="0.00" />
                  </div>
                  <div className="pkg-form-group">
                    <label className="pkg-label">Kid Price</label>
                    <input type="number" className="pkg-input" value={item.KidPrice || 0} onChange={(e) => handleUpdatePriceSharing(index, 'KidPrice', parseFloat(e.target.value) || 0)} min="0" step="0.01" placeholder="0.00" />
                  </div>
                   <div className="pkg-form-group">
                    <label className="pkg-label">Infant Price</label>
                    <input type="number" className="pkg-input" value={item.InfantPrice || 0} onChange={(e) => handleUpdatePriceSharing(index, 'InfantPrice', parseFloat(e.target.value) || 0)} min="0" step="0.01" placeholder="0.00" />
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        <div className="pkg-section" style={{ marginBottom: 0 }}>
          <div className="pkg-estimation-toggle" onClick={() => setShowEstimation(!showEstimation)}>
            <span>💰 Cost Breakdown (Flight / Hotel / Sightseeing / Transfer / Other)</span>
            <span>{showEstimation ? '▼' : '▶'}</span>
          </div>
          {showEstimation && (
            <div className="pkg-estimation-body">
              <div className="pkg-grid-3">
                <div className="pkg-form-group">
                  <label className="pkg-label">Flight</label>
                  <input type="number" className="pkg-input" name="FlightPrice" value={formData.FlightPrice} onChange={handleInputChange} min="0" step="0.01" placeholder="0.00" />
                </div>
                <div className="pkg-form-group">
                  <label className="pkg-label">Hotel</label>
                  <input type="number" className="pkg-input" name="HotelPrice" value={formData.HotelPrice} onChange={handleInputChange} min="0" step="0.01" placeholder="0.00" />
                </div>
                <div className="pkg-form-group">
                  <label className="pkg-label">Sightseeing</label>
                  <input type="number" className="pkg-input" name="SightSeeingPrice" value={formData.SightSeeingPrice} onChange={handleInputChange} min="0" step="0.01" placeholder="0.00" />
                </div>
              </div>
              <div className="pkg-grid-3">
                <div className="pkg-form-group">
                  <label className="pkg-label">Transfer</label>
                  <input type="number" className="pkg-input" name="TransferPrice" value={formData.TransferPrice} onChange={handleInputChange} min="0" step="0.01" placeholder="0.00" />
                </div>
                <div className="pkg-form-group">
                  <label className="pkg-label">Other</label>
                  <input type="number" className="pkg-input" name="OtherPrice" value={formData.OtherPrice} onChange={handleInputChange} min="0" step="0.01" placeholder="0.00" />
                </div>
                <div className="pkg-form-group">
                  <label className="pkg-label">Purchase Price</label>
                  <input type="number" className="pkg-input" name="PurchasePrice" value={formData.PurchasePrice} onChange={handleInputChange} min="0" step="0.01" placeholder="0.00" />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  // Step 4 — Settings & Contact
  const renderStep4 = () => (
    <div>
      <h2 className="pkg-step-title">Settings &amp; Contact</h2>
      <p className="pkg-step-subtitle">Control visibility of this package and who travelers should contact.</p>

      <div className="pkg-section">
        <div className="pkg-grid-3">
          <div className="pkg-form-group">
            <label className="pkg-label">Status</label>
            <select className="pkg-select" name="Status" value={formData.Status} onChange={handleInputChange}>
              {statusOptions.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div className="pkg-form-group">
            <label className="pkg-label">Is Live</label>
            <div className="pkg-toggle-row">
              <label className="pkg-switch">
                <input type="checkbox" name="IsLive" checked={formData.IsLive} onChange={handleInputChange} />
                <span className="pkg-switch-slider"></span>
              </label>
              <span className="pkg-toggle-label">Make this package live</span>
            </div>
          </div>
          <div className="pkg-form-group">
            <label className="pkg-label">Show on Website</label>
            <div className="pkg-toggle-row">
              <label className="pkg-switch">
                <input type="checkbox" name="IsWebsite" checked={formData.IsWebsite} onChange={handleInputChange} />
                <span className="pkg-switch-slider"></span>
              </label>
              <span className="pkg-toggle-label">Display on public website</span>
            </div>
          </div>
        </div>
      </div>

      <div className="pkg-contact-panel">
        <div className="pkg-section-heading" style={{ border: 'none', paddingBottom: 0, color: 'var(--pkg-primary-dark)' }}>
          📞 Contact Information
          {selectedDmc && (
            <span style={{ fontSize: '12px', fontWeight: 'normal', color: 'var(--pkg-text-secondary)', marginLeft: '8px' }}>
              (Auto-filled from DMC: {selectedDmc.companyName})
            </span>
          )}
        </div>
        <div className="pkg-grid-3">
          <div className="pkg-form-group">
            <label className="pkg-label">Contact Name</label>
            <input 
              className="pkg-input" 
              name="ContactName" 
              value={formData.ContactName || ''} 
              onChange={handleInputChange} 
              placeholder="Name"
              readOnly={!!selectedDmc}
              style={selectedDmc ? { backgroundColor: 'var(--pkg-bg-soft)' } : {}}
            />
          </div>
          <div className="pkg-form-group">
            <label className="pkg-label">Email</label>
            <input 
              type="email" 
              className="pkg-input" 
              name="ContactEmail" 
              value={formData.ContactEmail || ''} 
              onChange={handleInputChange} 
              placeholder="Email"
              readOnly={!!selectedDmc}
              style={selectedDmc ? { backgroundColor: 'var(--pkg-bg-soft)' } : {}}
            />
          </div>
          <div className="pkg-form-group">
            <label className="pkg-label">Phone Number</label>
            <input 
              type="tel" 
              className="pkg-input" 
              name="ContactPhoneNumber" 
              value={formData.ContactPhoneNumber || ''} 
              onChange={handleInputChange} 
              placeholder="Phone"
              readOnly={!!selectedDmc}
              style={selectedDmc ? { backgroundColor: 'var(--pkg-bg-soft)' } : {}}
            />
          </div>
        </div>
      </div>
    </div>
  );

  // Step 5 — Itinerary
  const renderStep5 = () => (
    <div>
      <h2 className="pkg-step-title">Itinerary</h2>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px', marginBottom: '16px' }}>
        <p className="pkg-step-subtitle" style={{ margin: 0 }}>Add each day with its flights, hotels, sightseeing, and transfers.</p>
        <button className="pkg-btn pkg-btn-primary" type="button" onClick={handleAddItineraryDay}>+ Add Day</button>
      </div>

      {formData.Itinerary.length === 0 ? (
        <div className="pkg-empty-state">
          <span className="pkg-empty-icon">🗓️</span>
          <p>No itinerary days added yet. Click "Add Day" to start.</p>
        </div>
      ) : (
        formData.Itinerary.map((day, index) => (
          <div key={index} className="pkg-itinerary-day">
            <div className="pkg-itinerary-day-header">
              <h3>📅 Day {day.Day || index + 1}</h3>
              <div className="pkg-day-actions">
                <button className="pkg-btn pkg-btn-xs pkg-btn-secondary" onClick={() => handleAddFlight(index)} type="button">✈️ Add Flight</button>
                <button className="pkg-btn pkg-btn-xs pkg-btn-secondary" onClick={() => handleAddHotel(index)} type="button">🏨 Add Hotel</button>
                <button className="pkg-btn pkg-btn-xs pkg-btn-secondary" onClick={() => handleAddSightseeing(index)} type="button">🗺️ Add Sightseeing</button>
                <button className="pkg-btn pkg-btn-xs pkg-btn-secondary" onClick={() => handleAddTransfer(index)} type="button">🚗 Add Transfer</button>
                <button className="pkg-btn-remove" onClick={() => handleRemoveItineraryDay(index)} type="button">Remove Day</button>
              </div>
            </div>

            <div className="pkg-grid-2">
              <div className="pkg-form-group">
                <label className="pkg-label">Title</label>
                <input className="pkg-input" value={day.Title || ''} onChange={(e) => handleItineraryChange(index, 'Title', e.target.value)} placeholder="Day title" />
              </div>
              <div className="pkg-form-group">
                <label className="pkg-label">Location</label>
                <input className="pkg-input" value={day.Location || ''} onChange={(e) => handleItineraryChange(index, 'Location', e.target.value)} placeholder="Location" />
              </div>
            </div>
            <div className="pkg-form-group">
              <label className="pkg-label">Description</label>
              <textarea className="pkg-textarea" style={{ minHeight: '48px' }} rows={2} value={day.Description || ''} onChange={(e) => handleItineraryChange(index, 'Description', e.target.value)} placeholder="Description" />
            </div>
            <div className="pkg-grid-3">
              <div className="pkg-form-group">
                <label className="pkg-label">Meals</label>
                <input className="pkg-input" value={day.Meals || ''} onChange={(e) => handleItineraryChange(index, 'Meals', e.target.value)} placeholder="e.g., Breakfast" />
              </div>
              <div className="pkg-form-group">
                <label className="pkg-label">Date</label>
                <input type="date" className="pkg-input" value={day.Date || ''} onChange={(e) => handleItineraryChange(index, 'Date', e.target.value)} />
              </div>
              <div className="pkg-form-group">
                <label className="pkg-label">Note</label>
                <input className="pkg-input" value={day.Note || ''} onChange={(e) => handleItineraryChange(index, 'Note', e.target.value)} placeholder="Special note" />
              </div>
            </div>

            {(day.Flights || []).length > 0 && (
              <div style={{ marginTop: '10px' }}>
                <div className="pkg-section-heading">✈️ Flights</div>
                {day.Flights.map((flight, fIdx) => (
                  <FlightSection
                    key={fIdx}
                    flight={flight}
                    index={fIdx}
                    onUpdate={(flightIndex, updatedFlight) => handleUpdateFlight(index, flightIndex, updatedFlight)}
                    onRemove={(flightIndex) => handleRemoveFlight(index, flightIndex)}
                  />
                ))}
              </div>
            )}

            {(day.Hotels || []).length > 0 && (
              <div style={{ marginTop: '10px' }}>
                <div className="pkg-section-heading">🏨 Hotels</div>
                {day.Hotels.map((hotel, hIdx) => (
                  <HotelSection
                    key={hIdx}
                    hotel={hotel}
                    index={hIdx}
                    onUpdate={(hotelIndex, updatedHotel) => handleUpdateHotel(index, hotelIndex, updatedHotel)}
                    onRemove={(hotelIndex) => handleRemoveHotel(index, hotelIndex)}
                  />
                ))}
              </div>
            )}

            {(day.Sightseeing || []).length > 0 && (
              <div style={{ marginTop: '10px' }}>
                <div className="pkg-section-heading">🗺️ Sightseeing</div>
                {day.Sightseeing.map((ss, sIdx) => (
                  <SightseeingSection
                    key={sIdx}
                    sightseeing={ss}
                    index={sIdx}
                    onUpdate={(ssIndex, updatedSS) => handleUpdateSightseeing(index, ssIndex, updatedSS)}
                    onRemove={(ssIndex) => handleRemoveSightseeing(index, ssIndex)}
                  />
                ))}
              </div>
            )}

            {(day.Transfers || []).length > 0 && (
              <div style={{ marginTop: '10px' }}>
                <div className="pkg-section-heading">🚗 Transfers</div>
                {day.Transfers.map((transfer, tIdx) => (
                  <TransferSection
                    key={tIdx}
                    transfer={transfer}
                    index={tIdx}
                    onUpdate={(transferIndex, updatedTransfer) => handleUpdateTransfer(index, transferIndex, updatedTransfer)}
                    onRemove={(transferIndex) => handleRemoveTransfer(index, transferIndex)}
                  />
                ))}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );

  // Step 6 — Inclusions, Exclusions & Terms
  const renderStep6 = () => (
    <div>
      <h2 className="pkg-step-title">Inclusions, Exclusions &amp; Terms</h2>
      <p className="pkg-step-subtitle">Set traveler expectations clearly — what's included, what isn't, and the fine print.</p>

      <div className="pkg-subtab-pills">
        {inclusionSubTabs.map(subTab => (
          <button
            key={subTab.id}
            className={`pkg-subtab-pill ${inclusionActiveSubTab === subTab.id ? 'active' : ''}`}
            onClick={() => setInclusionActiveSubTab(subTab.id)}
            type="button"
          >
            {subTab.label}
          </button>
        ))}
      </div>

      {inclusionActiveSubTab === 'inclusions' && (
        <div>
          <div className="pkg-add-row">
            <input className="pkg-input" id="inclusionInput" placeholder="Add included item..." onKeyPress={(e) => { if (e.key === 'Enter') { handleAddArrayItem('Inclusions', e.target.value); e.target.value = ''; } }} />
            <button className="pkg-btn pkg-btn-secondary" type="button" onClick={() => { const input = document.getElementById('inclusionInput'); handleAddArrayItem('Inclusions', input.value); input.value = ''; }}>Add</button>
          </div>
          <div className="pkg-chip-list">
            {formData.Inclusions.map((item, index) => (
              <span key={index} className="pkg-chip">✅ {item}<span className="pkg-chip-remove" onClick={() => handleRemoveArrayItem('Inclusions', index)}>×</span></span>
            ))}
            {formData.Inclusions.length === 0 && <p className="pkg-empty-hint">No inclusions added yet.</p>}
          </div>
        </div>
      )}

      {inclusionActiveSubTab === 'exclusions' && (
        <div>
          <div className="pkg-add-row">
            <input className="pkg-input" id="exclusionInput" placeholder="Add excluded item..." onKeyPress={(e) => { if (e.key === 'Enter') { handleAddArrayItem('Exclusions', e.target.value); e.target.value = ''; } }} />
            <button className="pkg-btn pkg-btn-secondary" type="button" onClick={() => { const input = document.getElementById('exclusionInput'); handleAddArrayItem('Exclusions', input.value); input.value = ''; }}>Add</button>
          </div>
          <div className="pkg-chip-list">
            {formData.Exclusions.map((item, index) => (
              <span key={index} className="pkg-chip">❌ {item}<span className="pkg-chip-remove" onClick={() => handleRemoveArrayItem('Exclusions', index)}>×</span></span>
            ))}
            {formData.Exclusions.length === 0 && <p className="pkg-empty-hint">No exclusions added yet.</p>}
          </div>
        </div>
      )}

      {inclusionActiveSubTab === 'terms' && (
        <div>
          <div className="pkg-grid-2">
            <div className="pkg-form-group">
              <label className="pkg-label">Term Title</label>
              <input className="pkg-input" id="termTitle" placeholder="e.g., Cancellation Policy" />
            </div>
            <div className="pkg-form-group">
              <label className="pkg-label">Description</label>
              <input className="pkg-input" id="termDescription" placeholder="Description" />
            </div>
          </div>
          <button className="pkg-btn pkg-btn-secondary" style={{ marginBottom: '14px' }} type="button" onClick={handleAddTerm}>+ Add Term</button>
          <div className="pkg-terms-list">
            {formData.Terms.map((term, index) => (
              <div key={index} className="pkg-term-card">
                <div>
                  <strong>{term.Title}</strong>
                  {term.Description && <p>{term.Description}</p>}
                </div>
                <span className="pkg-chip-remove" onClick={() => handleRemoveTerm(index)}>×</span>
              </div>
            ))}
            {formData.Terms.length === 0 && <p className="pkg-empty-hint">No terms added yet.</p>}
          </div>
        </div>
      )}
    </div>
  );

  const renderStepContent = () => {
    switch (currentStep) {
      case 1: return renderStep1();
      case 2: return renderStep2();
      case 3: return renderStep3();
      case 4: return renderStep4();
      case 5: return renderStep5();
      case 6: return renderStep6();
      default: return null;
    }
  };

  if (authLoading) {
    return (
      <div className="pkg-loading-overlay">
        <div className="pkg-spinner"></div>
      </div>
    );
  }

  if (!user) {
    navigate('/');
    return null;
  }

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
            <PackageTabs pageName="CREATEPACKAGE" />
          <div className="pkg-create">
            {/* AI Package Type Selection Modal */}
            <Modal show={showPackageTypeSelectionModal} onHide={() => setShowPackageTypeSelectionModal(false)} centered>
              <Modal.Header closeButton>
                <Modal.Title>Select AI Package Type</Modal.Title>
              </Modal.Header>
              <Modal.Body className="text-center">
                <p className="mb-4">What kind of package would you like to generate?</p>
                <div className="d-grid gap-3">
                  <button
                    className="btn btn-primary btn-lg"
                    onClick={handleNavigateToFlightPackage}
                  >
                    <i className="ri-plane-line me-2"></i>Flight Package
                    <small className="d-block text-white-50">Flights included</small>
                  </button>
                  <button className="btn btn-warning btn-lg" onClick={handleNavigateToLandPackage}>
                    <i className="ri-road-map-line me-2"></i>Land Package
                    <small className="d-block text-white-50">Flights are not included</small>
                  </button>
                </div>
              </Modal.Body>
            </Modal>

            {toast && (
              <Toast
                message={toast.message}
                type={toast.type}
                onClose={() => setToast(null)}
              />
            )}

            {isLoading && (
              <div className="pkg-loading-overlay">
                <div className="pkg-spinner"></div>
              </div>
            )}

            <>
                <div className="pkg-topbar">
                  <div>
                    <h1>✨ Create New Package</h1>
                    <p>Fill in all details including flights, hotels, sightseeing, and transfers</p>
                  </div>
                  <div className="pkg-topbar-actions">
                    <button className="pkg-btn pkg-btn-secondary" onClick={() => navigate('/packageslist')} type="button">← Back</button>
                    <button className="pkg-btn pkg-btn-warning" onClick={handlePreview} type="button">👁️ Preview</button>
                    <button className="pkg-btn pkg-btn-secondary" onClick={handlePrint} type="button">📄 PDF/Print</button>
                    {/* <button
                      onClick={handleGenerateWithAIClick}
                      className="pkg-ai-link"
                      disabled={isCheckingConnects}
                      type="button"
                    >
                      {isCheckingConnects ? (
                        <>
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          Processing...
                        </>
                      ) : (
                        <>
                          <i className="ri-robot-line"></i> Create with AI
                        </>
                      )}
                    </button> */}
                     <button
                      className="pkg-btn pkg-btn-primary"
                      onClick={handleSubmit}
                      disabled={isLoading}
                      type="button"
                    >
                      {isLoading ? 'Creating...' : '✨ Create Package'}
                    </button>
                  </div>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="pkg-stepper">
                    {STEPS.map((step, idx) => (
                      <React.Fragment key={step.id}>
                        <button
                          type="button"
                          className={`pkg-step ${currentStep === step.id ? 'pkg-step-active' : ''} ${isStepComplete(step.id) ? 'pkg-step-complete' : ''}`}
                          onClick={() => goToStep(step.id)}
                        >
                          <span className="pkg-step-circle">
                            {isStepComplete(step.id) && currentStep !== step.id ? '✓' : step.id}
                          </span>
                          <span className="pkg-step-label">{step.label}</span>
                        </button>
                        {idx < STEPS.length - 1 && <span className="pkg-step-line" />}
                      </React.Fragment>
                    ))}
                  </div>

                  <div className="pkg-card">
                    <div className="pkg-step-panel">
                      {renderStepContent()}
                    </div>
                  </div>

                  <div className="pkg-footer-nav">
                    <div className="pkg-footer-left">
                      <button type="button" className="pkg-btn pkg-btn-secondary" onClick={() => navigate('/packageslist')}>Cancel</button>
                      <button
                        type="button"
                        className="pkg-btn pkg-btn-secondary"
                        onClick={() => { if (window.confirm('Are you sure you want to clear all fields?')) { window.location.reload(); } }}
                      >
                        Reset
                      </button>
                    </div>
                    <div className="pkg-footer-right">
                      {currentStep > 1 && (
                        <button type="button" className="pkg-btn pkg-btn-secondary" onClick={goBack}>← Back</button>
                      )}
                      {currentStep < 6 ? (
                        <button type="button" className="pkg-btn pkg-btn-primary" onClick={goNext}>Next →</button>
                      ) : null}
                    </div>
                  </div>
                </form>
              </>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MasterPackageCreate;